import { connect } from "react-redux"
import { useEffect, useState } from 'react'


import { Link } from "react-router-dom"

  function ProfileTrips({
    user,    
  }) {

    useEffect(()=>{
    },[])

    const [option, setOption] = useState(true);

    function obtenerDatosFecha(fechaStr) {
        const fecha = new Date(fechaStr);
        const dia = fecha.getUTCDate();
        const año = fecha.getUTCFullYear();
        const mes = new Intl.DateTimeFormat('es-ES', { month: 'long' }).format(fecha);
        const mesCapitalizado = mes.charAt(0).toUpperCase() + mes.slice(1);
        
        return `${dia}, ${mesCapitalizado} de ${año}`;
    }

    return (
      <>
       <div className="flex-1 bg-white pb-10 px-20">
            <div className="sticky top-20 flex justify-center mb-10">
                <div className="shadow-lg inline-flex gap-x-2 bg-gray-100 p-2 rounded-3xl">
                    <button onClick={() => setOption(true)} className={`transition-colors text-lg duration-300 px-8 py-2 rounded-3xl ${option ? "bg-white text-blue-green shadow" : "bg-gray-100"}`}>Publicados</button>
                    <button onClick={() => setOption(false)} className={`transition-colors text-lg duration-300 px-8 py-2 rounded-3xl ${option ? "bg-gray-100" : "bg-white text-blue-green shadow"}`}>Reservados</button>                
                </div>
            </div>
            <div className="max-w-screen-xl mx-auto pb-10">
                <div className={`${option ? 'block' : 'hidden'}`}>
                    <h2 className="ml-3 text-gray-700 font-bold text-3xl">
                        Trips Publicados
                    </h2>
                    <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
                        {user?.trips_creados.map((item, idx) => ( 
                            <div key={idx}>
                                <Link to={`/trip/${item.slug}`}>
                                <div className="flex items-center gap-x-5">
                                    <img
                                        src={`${item.event.thumbnail}`}
                                        className="object-cover h-24 w-24 rounded-xl"
                                    />
                                    <div>
                                        <p className="font-semibold text-lg">{item.event.title}</p>
                                        <div className="flex items-center gap-x-2">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
                                            </svg>
                                            <p className="pb-2">{item.event.ciudad.name}</p>
                                        </div>
                                        <div className="flex items-center gap-x-2">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
                                            </svg>
                                            <p className="">{obtenerDatosFecha(item.event.fecha)}</p>
                                        </div>
                                    </div>
                                </div>
                                </Link>
                            </div>
                        ))} 
                    </div>
                </div>
                <div className={`${option ? 'hidden' : 'block'}`}>
                    <h2 className="ml-3 mt-6 text-gray-700 font-bold text-3xl">
                        Trips Reservados
                    </h2>
                    <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
                        {user?.trips_reservados.map((item, idx) => ( 
                            <div key={idx}>
                                <Link to={`/trip/${item.slug}`}>
                                <div className="flex items-center gap-x-5">
                                    <img
                                        src={`${item.event.thumbnail}`}
                                        className="object-cover h-24 w-24 rounded-xl"
                                    />
                                    <div>
                                        <p className="font-semibold text-lg">{item.event.title}</p>
                                        <div className="flex items-center gap-x-2">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
                                            </svg>
                                            <p className="pb-2">{item.event.ciudad.name}</p>
                                        </div>
                                        <div className="flex items-center gap-x-2">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
                                            </svg>
                                            <p className="">{obtenerDatosFecha(item.event.fecha)}</p>
                                        </div>
                                    </div>
                                </div>
                                </Link>
                            </div>
                        ))} 
                    </div>
                </div>
            </div>
       </div>
      </>
    )
  }

  const mapStateToProps=state=>({
    user: state.auth.user,
  })

  export default connect(mapStateToProps,{
  })(ProfileTrips)